// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/main.scss
// module id = 185
// module chunks = 0